import { Typography } from "@circle-react-shared/uikit/Typography";
import { Counter } from "@circle-react/components/Events/Counter";
import { ShowPageLink } from "@circle-react/components/PostsV3/PostViewListItem/ShowPageLink";
import { useCurrentPostHelpers } from "@circle-react/components/PostsV3/useCurrentPostHelpers";
import { useCurrentPostContext } from "@circle-react/contexts/currentPostContext";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import classnames from "classnames";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export const PostName = () => {
  const { post, canManagePost } = useCurrentPostHelpers();
  const { usedIn } = useCurrentPostContext();
  const isSmScreen = useSmScreenMediaQuery();
  const shouldRenderPostNameInMinimalPostModal =
    usedIn === "minimal-post-modal" && isSmScreen;

  if (!post.name || (usedIn === "minimal-post-modal" && !isSmScreen)) {
    return null;
  }

  if (shouldRenderPostNameInMinimalPostModal) {
    return (
      <div className="overflow-anywhere">
        <Typography.TitleMd>{post.name}</Typography.TitleMd>
      </div>
    );
  }

  const { event_setting_attributes: eventData } = post || {};
  const { starts_at: startsAt, ends_at: endsAt } = eventData || {};

  return (
    <div
      className={anchorClassNames("post__header", {
        "post-meta--hidden": post.hide_meta_info,
      })}
      data-testid="post-header"
    >
      {startsAt && endsAt && (
        <Counter startsAt={startsAt} endsAt={endsAt} status={post?.status} />
      )}
      <h1
        className={classnames(
          anchorClassNames("post__title", {
            "with-admin-actions": canManagePost,
          }),
          "text-xl font-bold leading-7",
        )}
        data-testid="post-title"
      >
        <ShowPageLink
          post={post}
          className="!text-darkest overflow-anywhere focus-visible:outline-secondary focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
          shouldOpenPostModal
        >
          {post.name}
        </ShowPageLink>
      </h1>
    </div>
  );
};
